import React, { useEffect, useState } from 'react'
import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import { Quiz, QuizMetrics } from './QuizMetricsModal';
import { Account, getAccountName } from './ManageAccounts';
import { Bar, BarChart, Legend, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts'
import QuizTopicCard from 'components/QuizTopicCard';
import { TOPICS } from 'utils';
import QuizesList from 'components/QuizList';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
): MenuItem {
    return {
        key,
        icon,
        children,
        label,
        type,
    } as MenuItem;
}

export type UserWiseMetrics = {
    [key: number]: {
        total_score: number,
        total_questions: number,
        quiz_count: number,
        user: Account,
        quizzes: Quiz[]
    }
}

type Props = {
    metrics: UserWiseMetrics
}

export default function UserWiseQuizzes({ metrics }: Props) {
    const [user, setUser] = useState<number | null>(null)

    useEffect(() => {
        if (Object.keys(metrics).length > 0) {
            setUser(parseInt(Object.keys(metrics)[0]))
        }
    }, [])


    const getUserChartData = () => {
        let topicWiseData: { [key: string]: { total: number, correct: number } } = {}
        if (user) {
            metrics[user].quizzes.map(q => {
                topicWiseData[q.topic] = topicWiseData[q.topic] || { total: 0, correct: 0 }
                topicWiseData[q.topic].total += q.question_count
                topicWiseData[q.topic].correct += q.score
            })
        }
        return Object.entries(topicWiseData).map(([topic, topicData]) => {
            return {
                topic,
                total: topicData.total,
                score: topicData.correct,
                incorrect: topicData.total - topicData.correct
            }
        })
    }
    const chartData = getUserChartData()
    let topicValues = chartData.map(c => c.topic)
    let topics = TOPICS.filter(t => topicValues.includes(t.topic))

    let today = new Date()
    let sevenDaysBefore = new Date()
    sevenDaysBefore.setDate(today.getDate() - 7);
    console.log(metrics, TOPICS, sevenDaysBefore)

    return (
        <div>
            <h3 className='is-size-5 mb-3'>User data</h3>
            <div className="columns">
                <div className="column">
                    <Menu
                        onClick={(e) => {
                            console.log("click", e)
                            setUser(parseInt(e.key))
                        }}
                        style={{ width: 256 }}
                        selectedKeys={user ? [user?.toString()] : []}
                        mode="inline"
                        items={[
                            ...Object.entries(metrics).map(([user_id, m]) => {
                                return getItem(m.user.firstName, user_id, null)
                            })
                        ]}
                    />
                </div>
                {user
                    ? <div className='columns ' style={{ flexWrap: "wrap" }}>
                        <div className='column is-half'>
                            <p className='mb-3'>Viewing data for <strong>{getAccountName(metrics[user].user)}</strong> </p>
                            <ResponsiveContainer height={400}>
                                <BarChart data={chartData}>
                                    <Bar dataKey="score" fill="#00d1b2" stackId="a" />
                                    <Bar dataKey="incorrect" fill="#f65868" stackId="a" />
                                    <XAxis dataKey="topic" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend margin={{ top: 20 }} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                        <div className="column is-half">
                            <h5 className='is-size-5 mb-5'>Learning recommendations</h5>
                            {getAccountName(metrics[user].user)} has taken {chartData.map(c => {
                                return <p key={c.topic}><strong>{c.total}</strong> {`questions in`} <strong>{c.topic}</strong></p>
                            })}
                        </div>
                        {topics.map(t => {
                            console.log(t.topic, user)
                            return <div className='column is-half'>
                                <QuizTopicCard
                                    key={t.topic + user}
                                    user_id={user}
                                    after={sevenDaysBefore}
                                    onPercentObtained={() => { }}
                                    topic={t}
                                    getDetail={(quizes) => <QuizesList quizes={quizes} />}
                                />
                            </div>
                        })}
                    </div>
                    : <div>Select a user to view the data</div>
                }
            </div>
        </div>
    )
}